module.exports = __webpack_public_path__ + "82ec88f7e53b8638df1919b2c9ed119b.pdf";